<template>
  <generic-modal
    size
    :title="$t('customer email configuration')"
    icon="at"
    image="/images/icons/configuration.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <generic-container
        v-bind:show_plus="true"
        icon="at"
        :title="$t('email address types')"
        v-on:add="add_type"
      >
        <div class="ui form" ref="form">
          <div class="two fields" v-for="(type, index) in types" :key="index">
            <div class="twelve wide column field">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="types[index].name" />
            </div>
            <div class="one wide column field">
              <label for>{{$t("options")}}</label>
              <div class="ui basic icon labeled button" v-on:click="remove_type(type, index)">
                <i class="red trash icon"></i>
                {{ $t("remove")}}
              </div>
            </div>
          </div>
          <div class="ui error message"></div>
        </div>
      </generic-container>
      <generic-container
        v-bind:show_plus="true"
        icon="envelope"
        :title="$t('email templates')"
        v-on:add="add_template"
      >
        <div class="ui form" ref="form_templates">
          <div class="three fields" v-for="(type, index) in templates" :key="index">
            <div class="five wide column field">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="templates[index].name" />
            </div>
            <div class="seven wide column field">
              <label for>{{ $t("template") }}</label>
              <textarea name="template" rows="2" v-model="templates[index].template"></textarea>
            </div>
            <div class="one wide column field">
              <label for>{{$t("options")}}</label>
              <div class="ui basic icon labeled button" v-on:click="remove_template(type, index)">
                <i class="red trash icon"></i>
                {{ $t("remove")}}
              </div>
            </div>
          </div>
          <div class="ui error message"></div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "../../utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";

export default {
  components: {
    "generic-modal": GenericModal,
    "generic-container": GenericContainer
  },
  computed: {
    form_types() {
      return window.jQuery(this.$refs.form).form({
        fields: {
          name: ["empty"]
        }
      });
    },
    form_templates() {
      return window.jQuery(this.$refs.form_templates).form({
        fields: {
          name: ["empty"],
          template: ["empty"]
        },
        // eslint-disable-next-line no-unused-vars
        onSuccess(event, fields) {
          // console.log(event, fields);
        }
      });
    }
  },
  data() {
    return {
      types: [],
      templates: []
    };
  },
  methods: {
    add_type() {
      let type = { id: v4(), name: "" };
      this.types.push(type);
    },
    remove_type(type, index) {
      this.types.splice(index, 1);
    },
    add_template() {
      let template = { id: v4(), name: "", template: "" };
      this.templates.push(template);
    },
    remove_template(type, index) {
      this.templates.splice(index, 1);
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid =
          vm.form_types.form("validate form") &&
          vm.form_templates.form("validate form");
        if (!isValid) reject();
        else {
          local_api(vm, "post", "/customer_email/do-save-configuration", {
            s: { email_types: vm.types, templates: vm.templates }
          })
            .then(() => {
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/customer_email/do-get-configuration")
      .then(conf => {
        if (conf && conf.setup && conf.setup.email_types)
          vm.types = conf.setup.email_types;
        if (conf && conf.setup && conf.setup.templates)
          vm.templates = conf.setup.templates;
      })
      .catch(err => {
        console.error(err);
      });
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {});
  }
};
</script>
